import { useState } from 'react';
import { SplineScene } from "@/components/ui/spline";
import { AiChatDialog } from './ai/AiChatDialog';
import { Button } from './ui/button';

const AiHelper = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleInteraction = () => {
    console.log('AI Helper button clicked/tapped');
    setIsOpen(true);
  };

  return (
    <>
      <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50">
        <Button
          variant="ghost"
          className="relative h-16 w-16 md:h-28 md:w-28 rounded-full p-0 hover:scale-105 transition-transform duration-300 bg-background/20 backdrop-blur-sm border border-primary/20 overflow-hidden touch-none"
          onClick={handleInteraction}
          onTouchEnd={(e) => {
            e.preventDefault();
            handleInteraction();
          }}
        >
          <SplineScene 
            className="absolute inset-0 w-full h-full scale-[1.15] transform pointer-events-none"
            scene="https://prod.spline.design/azMWtV2gEYMY47DL/scene.splinecode"
          />
        </Button>
      </div>
      <AiChatDialog open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};

export default AiHelper;